/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-09-19 10:25:05
 * @LastEditTime: 2023-11-01 13:56:09
 * @LastEditors: WangYuhan
 */
import defaultSettings from '@/settings';

const title = defaultSettings.title || '牛运宝';

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return ` ${title} - ${pageTitle}`;
  }
  return `${title}`;
}
